import classNames from 'classnames';

import {Icon} from 'components/atoms/Media/Icon';
import * as React from 'react';

import './style.scss';

interface Props {
    id?:string;
    className?: string;
    small?: boolean;
    sheer?: boolean;
    next?: boolean;
    onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const SliderArrow: React.FunctionComponent<Props> = ({id: _id, className, small, sheer, next, onClick}) => {
    const arrowClasses = classNames('slider-arrow', className, {
        'slider-arrow--small': small,
        'slider-arrow--sheer': sheer,
    });

    return (
        <Icon
            onClick={onClick}
            className={arrowClasses}
            name="chevron"
            size={small ? 16 : 24}
            right={next}
            left={!next}
        />
    )
};
